import { render, staticRenderFns } from "./ProductAgreement.vue?vue&type=template&id=6ccb0e9e&scoped=true"
import script from "./ProductAgreement.vue?vue&type=script&lang=ts"
export * from "./ProductAgreement.vue?vue&type=script&lang=ts"
import style0 from "./ProductAgreement.vue?vue&type=style&index=0&id=6ccb0e9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccb0e9e",
  null
  
)

export default component.exports